import React from 'react'
import { Row } from '@tanstack/react-table'

import DateCustomFieldCell from './Date'
import TextCustomFieldCell from './Text'

const ELEMENT_MAP = {
  text: TextCustomFieldCell,
  multiline: TextCustomFieldCell,
  'date-only': DateCustomFieldCell,
  'date-time': DateCustomFieldCell,
  'month-year': DateCustomFieldCell,
  dropdown: TextCustomFieldCell,
  multiselect: TextCustomFieldCell,
  boolean: TextCustomFieldCell,
  user: TextCustomFieldCell
}

type CustomFieldProps<T> = {
  row: Row<WithMeta<T>>
  customField: LocalCustomField
}

const CustomField = <T extends unknown>({
  row,
  customField
}: CustomFieldProps<T>) => {
  const Element = React.useMemo(() => {
    const fieldType = customField.field_type

    if (fieldType in ELEMENT_MAP) {
      return ELEMENT_MAP[fieldType]
    }

    console.warn(`Unknown object type: ${fieldType}`)
    return null
  }, [customField.field_type])

  const value = React.useMemo(() => {
    if (!row.original.meta) {
      return ''
    }

    // Verify correct data type
    const { meta } = row.original
    if (!Array.isArray(meta)) {
      return ''
    }

    const entry = meta.find(metaEntry => metaEntry.key === customField.id)
    return entry?.val ?? ''
  }, [row, customField])

  if (!Element) {
    return null
  }

  return <Element value={value} customField={customField} />
}
export default CustomField
